import { useCallback, useEffect } from 'react';

import type { NotificationSubscriptionResultPayload } from '@system/app';
import { NotificationEvents, useApp } from '@system/app';

export function useExportFileInfo() {
  const { notification, flags, toast } = useApp();

  const maintenance_mode = flags?.find(
    item => item.name === 'maintenance_mode',
  );

  const isMaintenanceMode = maintenance_mode?.value === 'on';

  const messageExportInfo = useCallback(
    (payload: NotificationSubscriptionResultPayload) => {
      toast.info(payload.data.message);
    },
    [toast],
  );

  useEffect(() => {
    if (!isMaintenanceMode) {
      const handlerLink = notification.subscribe(
        NotificationEvents.messageInfoExportFile,
        messageExportInfo,
      );
      return () => {
        notification.unsubscribe(
          NotificationEvents.messageInfoExportFile,
          handlerLink,
        );
      };
    }
  }, [isMaintenanceMode, notification, messageExportInfo]);

  return null;
}
